export default {
  'memberWelcome.title': 'Welcome to use Membership Card!',
  'memberWelcome.description': 'No matter where you are, we will provide you with the food you love to meet your food needs. Click the icon below to add your membership card.',
  'memberWelcome.wallet.loading': 'Loading wallet options...',
  'memberWelcome.existing.title': 'Welcome Back!',
  'memberWelcome.existing.content': 'This phone number is already registered. You can continue to use your membership benefits!',
  'memberWelcome.existing.button': 'Got it',
  'memberWelcome.viewCard': 'View Card',
  'memberWelcome.memberId': 'Member ID',
};
